import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { StageModeAPI } from "../talent/talent_api";

// StageMode: Generate StageLink QR Code for audience
export const useGenerateStageLinkQR = () => {
  return useMutation({
    mutationFn: (payload: { code: string }) =>
      StageModeAPI.post("/stagelink/qrcode", payload),
    onError: (error) => {
      console.error("Failed to generate StageLink QR code:", error);
    },
  });
};

export const useBookStage = () => {
  return useMutation({
    mutationFn: (payload: any) =>
      StageModeAPI.post("/stagecards/booking", payload),
    onError: (error) => {
      console.error("Failed to book StageSession:", error);
    },
  });
};
